import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 15,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    transition: 'transform 0.2s ease-in-out',
  },
  '&:hover': {
    [`& .${linearProgressClasses.bar}`]: {
      transform: 'scaleX(1.005)',
    },
  },
}));

interface ProgressDisplayProps {
  progress: number;
  message: string;
  totalVendors?: number;
  processedVendors?: number;
  totalVoucherTypes?: number;
  processedVoucherTypes?: number;
}

const ProgressDisplay: React.FC<ProgressDisplayProps> = ({
  progress,
  message,
  totalVendors,
  processedVendors,
  totalVoucherTypes,
  processedVoucherTypes,
}) => {
  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body1">{message}</Typography>
        <Box>
          {processedVendors && totalVendors && (
            <Typography variant="body2" color="text.secondary">
              {`Vendors: ${processedVendors}/${totalVendors}`}
            </Typography>
          )}
          {processedVoucherTypes && totalVoucherTypes && (
            <Typography variant="body2" color="text.secondary">
              {`Voucher Types: ${processedVoucherTypes}/${totalVoucherTypes}`}
            </Typography>
          )}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <BorderLinearProgress variant="determinate" value={progress} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            progress,
          )}%`}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProgressDisplay;
